import React, {useRef, useEffect} from "react";
import PropTypes from "prop-types";
import FauxHeaderInline from "components/Shared/FauxHeader/FauxHeaderInline";

// temporary fix/replacement for FauxHeader and resizeObserver bug that causes app to crash everytime? 
const FauxHeader2 = ({
  title,
  children
}) => {
  const childrenContainerRef = useRef(null);
  const childrenRef = useRef(null);

  useEffect(() => {
    const appHeader = document.querySelector(".app-header");
    const appBody = document.querySelector(".app-body");
    
    if (children.props.children.length > 0 && appHeader) {
      appHeader.style.display = "none";
      appBody.style.height = "calc(100vh - 50px - -25px)";
    }
    
    return () => {
      if (appHeader) {
        appHeader.style.display = "";
      }
      if (appBody) {
        appBody.style.height = "";
      }
    };
  }, [children]);

  return (
    <div className={"FauxHeader-Root"}>
      <div className={"FauxHeader-Title"}>{title}</div>
      <div ref={childrenContainerRef} className={"FauxHeader-ChildrenContainer"}>
        <div ref={childrenRef} className={"FauxHeader-Children"}>
          <FauxHeaderInline>
            {children}
          </FauxHeaderInline>
        </div>
      </div>
    </div>
);
};

FauxHeader2.defaultProps = {
  title: "",
};

FauxHeader2.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
};

export default FauxHeader2;